import {httpV3Post} from "../network";

/**
 * Sign up
 * @param {String} firstName
 * @param {String} lastName
 * @param {String} emailAddress
 * @param {String} password
 * @param {String[]} locations
 * @param {String} role
 */
const signupExistingLocation = (firstName, lastName, emailAddress, password, locations, role) => {
  return httpV3Post("/account/signupToExistingLocation", {firstName, lastName, emailAddress, password, locations, role})
    .then(r => {
      if (201 !== r.status || "success" !== r.data.result) {
        return Promise.reject({response: r});
      }

      return true;
    });
};

/**
 * Set up
 * @param {String} birthdate
 * @param {String} phoneNumber
 * @param {String[]} locations
 * @param {String} role
 * @param {String} experience
 */
const setupAccount = (birthdate, phoneNumber, locations, role, experience) => {
  return httpV3Post("/account/setup", {birthdate, phoneNumber, locations, role, experience})
    .then(r => {
      if (200 !== r.status || "success" !== r.data.result) {
        return Promise.reject({response: r});
      }

      return true;
    });
};

export {signupExistingLocation, setupAccount};
